module.exports = __webpack_public_path__ + "media/images/layout/footer_icons-bdf7a43de19f650f90f0575350811b20.svg";